import { dataLayerPush, TDataLayerPushArgument } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

const lazyCallbackDataLayerPush = (params: Omit<TDataLayerPushArgument<unknown>, 'category' | 'event'>): void => {
    return dataLayerPush({
        ...params,
        event: EVENTS.UAevent,
        category: CATEGORIES.applicationForm,
    });
};

export default lazyCallbackDataLayerPush;
